<template>
    <div id="caseList">
        <p>典型案例</p>
        <div>  
            <ul id="caseListBox">
                <li>
                    <div class="caseImg" @click="changeCase(1)"><img src="../../assets/imgs/case/cal1.png"></div>
                    <div class="caseTitle" @click="changeCase(1)">国家“十二·五”课题</div>
                </li>
                <li>
                    <div class="caseImg" @click="changeCase(2)"><img src="../../assets/imgs/case/cal2.png"></div>
                    <div class="caseTitle"  @click="changeCase(2)">沧州市产销差实时预警和在线分析计算平台</div>
                </li>
                <li>
                    <div class="caseImg" @click="changeCase(3)"><img src="../../assets/imgs/case/cal3.png"></div>
                    <div class="caseTitle"  @click="changeCase(3)">天津津南供水管网巡检管理系统</div>
                </li>
            </ul>
            <!-- 切换指示线 -->
            <div id="caseLineWrapper">
                <img src="../../assets/imgs/case/ico1.jpg" id="caseIco">
                <div id="caseLine"></div>
            </div> 
            <!-- 内容 -->
            <div id="caseTextBox">
                <!-- 十二五 -->
                <div class="classicDetailed" v-show="show1">
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设内容</p>
                        <div>
                            国家“十二五”科研课题《城市供水管网智能管理系统关键技术研究与示范》中，我司承接“基于SOA框架的供水系统智能化平台开发技术研究与示范”水专项中的“供水系统动态水力模型技术，安全事故应急子系统技术，智能平台服务产业化技术”的研究。
                        </div>
                    </div>
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设效果</p>
                        <div>
                            <div>
                                天津三博水科技有限公司开发的供水管网动态水力模型，供水管网在线监测预警应急系统，实现在线模拟，能够为供水企业管理者和实施者提供技术指导，提高供水管网的安全性。
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 沧州市供水管网水力模型 -->
                <div class="classicDetailed" v-show="show2">
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设内容</p>
                        <div>
                            在已建立分区的基础上，通过多级同步水平衡分计算，分析各区域产销差。同时通过漏点定位，初步分析漏损可能发生的位置，缩小漏失查找范围。
                        </div>
                    </div>
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设效果</p>
                        <div>
                            <div>
                                实现对各个级别的DBS区域进行产销差率实时监测和预警，并实现对各个DBS区域的在线漏损指标分析计算和汇总沧州供水范围内各级产销差，从而控制供水管网的产销差率，使之逐步降低，逐步稳定到最佳水平。
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 河北建投水务水务项目 -->
                <div class="classicDetailed" v-show="show3">
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设内容</p>
                        <div>
                           巡检系统可在区域定义巡检计划，提供巡检导航、消息发布、语音通讯、报警提示、位置共享和轨迹回放，以及自定义采集数据项、巡检平面图
                        </div>
                    </div>
                    <div>
                        <p class="caseTextTitle"><img src="../../assets/imgs/case/ico.png">建设效果</p>
                        <div>
                            <div>
                               改变了落后的巡检模式，借助信息技术手段，实现对供水设施巡检管理的电子化、信息化与智能化，提高工作效率。
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Screen3',
    data() {
        return {
            activeName: 'case1',
            show1:1,
            show2:0,
            show3:0,
        };
    },
    methods:{
        changeCase(e){
            let wra = document.getElementById("caseIco");
            if(e == 1){
                this.show1 = 1;
                this.show2 = 0;
                this.show3 = 0;
                wra.style.left = "160px"
            }else if(e == 2){
                this.show1 = 0;
                this.show2 = 1;
                this.show3 = 0;
                wra.style.left = "560px";
            }else if(e == 3){
                this.show1 = 0;
                this.show2 = 0;
                this.show3 = 1;
                wra.style.left = "935px";
            }
        }
    }
}
</script>

<style scoped>
    #caseList{
        margin: 0 auto;
        width: 1120px;
    }
    #caseList>p{
        text-align: center;
        font-size: 18px;
        padding: 25px 0;
    }
    #caseLineWrapper{
        padding-top: 15px;
        padding-bottom: 30px;
        position: relative;
    }
    #caseLineWrapper>img{
        width: 27px;
        position: absolute;
        top: 7px;
        left: 160px;
        transition:left .5s linear;
        -moz-transition:left .5s linear; /* Firefox 4 */
        -webkit-transition:left .5s linear; /* Safari and Chrome */
        -o-transition:left .5s linear; /* Opera */
    }
    #caseLine{
        width: 100%;
        height: 1px;
        background: #7fc7ff;
    }
    #caseListBox{
        overflow: hidden;
    }
    #caseListBox>li{
        float: left;
    }
    #caseListBox>li:nth-child(2){
        margin: 0 27.5px;
    }
    .caseImg>img{
        width: 355px;
        height: 220px;
        cursor: pointer;
    }
    .classicDetailed{
        text-indent: 24px;
    }
    .classicDetailed>div{
        margin-bottom:20px; 
        line-height: 25px;
    }
    .caseTitle{
        font-size: 16px;
        text-align: center;
        line-height: 47px;
        background: #f3f3f5;
        margin-top: 5px;
        cursor: pointer;
    }
    #caseTextBox{
        width: 1080px;
        background: #f6f6f7;
        padding: 20px;
    }
    .caseTextTitle{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
        display: flex;
        align-items: Center;        
    }
    .caseTextTitle>img{
        width: 20px;
        margin-right: 5px;
    }
</style>
